import { memo } from 'react';
import { SettingPin, GroupItem, toaster } from '@halo/ui-chat-react';
import { size, gt, includes } from 'lodash';
import type { Session } from '@halo/chat-sdk-react';
import { useAppStore } from '@halo/chat-sdk-react';
import { useTranslation } from 'react-i18next';

export const PinnedCard = memo(function PinnedCard({ session }: { session: Session | null }) {
  const { t } = useTranslation();
  const { pinnedSessions, changePinnedList } = useAppStore();
  const is_pinned = useMemo(
    () => includes(pinnedSessions, session?.chat_id),
    [pinnedSessions, session?.chat_id]
  );
  const isCollapsed = !!session?.collapse_group_id;
  const { run: onPinned } = useDebounceFn(
    (checked: boolean) => {
      if (checked && gt(size(pinnedSessions), 8)) {
        toaster.warning({
          title: t('chatSettings.pinnedChatsLimitReached'),
        });
        return;
      }
      if (!session?.chat_id) {
        return;
      }
      changePinnedList(session?.chat_id, checked, isCollapsed)
        .then(() => {
          toaster.success({
            title: checked ? t('chatSettings.pinned') : t('chatSettings.unpinned'),
          });
        })
        .catch((error) => {
          toaster.error({
            title: error,
          });
        });
    },
    { wait: 500 }
  );
  return (
    <GroupItem
      icon={<SettingPin />}
      title={t('chatSettings.pinToTop')}
      extra
      checked={is_pinned}
      onChange={onPinned}
    />
  );
});
